import React, { useEffect, useState } from 'react';

/** Smoothly-animated numeric readout. Presentational only. */
export const AnimatedNumber = ({ value, prefix = '', suffix = '', className = '', decimals = 0 }) => {
  const [display, setDisplay] = useState(value);
  useEffect(() => {
    const start = display, end = value, t0 = performance.now(), dur = 150;
    const step = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 4);
      setDisplay(start + (end - start) * eased);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const text = decimals > 0 ? display.toFixed(decimals) : Math.round(display).toLocaleString();
  return <span className={className}>{prefix}{text}{suffix}</span>;
};

export default AnimatedNumber;
